import ActionTypes from './types';

export const setConfig = (payload) => ({
    type: ActionTypes.SET_CONFIG,
    payload,
});